import PropTypes from 'prop-types';
import React from 'react';
import CriteriaTable from '../Criteria/CriteriaTable';
import { Card } from '@upsales/components';
import Elevio from 'App/babel/components/LegacyReactTemplates/elevio';

class FilterContainer extends React.Component {
	constructor(props) {
		super(props);

		const translate = Tools.$translate;

		this.lang = {
			editCriterias: translate('segment.editCriterias'),
			hideCriterias: translate('segment.hideCriterias'),
			numberOfCriterias: 'segment.numberOfCriterias',
			criteria: translate('admin.criteria').toLowerCase(),
			criterias: translate('admin.criterias').toLowerCase(),
			clickToEdit: translate('default.clickToEdit'),
			continue: translate('onboarding.continue'),
			title: translate('segment.filter.placeholder.title'),
			subtitle: translate('segment.filter.placeholder.subtitle')
		};
	}

	expanded() {
		const {
			filterSelection,
			segment,
			getExcludeFilter,
			getIncludeFilter,
			listState: { error },
			selectData
		} = this.props;

		const excludeFilter = getExcludeFilter(segment);

		const includeCards = [
			<Card space="mbxl" key="include-all">
				<CriteriaTable
					filters={getIncludeFilter(segment, false)}
					hideOrGroupToggle
					{...filterSelection}
					listStateError={error}
					selectData={selectData}
					criteriaSelectAnchor={document.getElementById('segment-filter-v2')}
				/>
			</Card>,
			<Card space="mbxl" key="include-any">
				<CriteriaTable
					filters={getIncludeFilter(segment, true)}
					hideOrGroupToggle
					{...filterSelection}
					listStateError={error}
					selectData={selectData}
					criteriaSelectAnchor={document.getElementById('segment-filter-v2')}
				/>
			</Card>
		];

		return (
			<div key="expanded" className="expanded-wrapper">
				<div className="header">
					<span className="title">
						{this.lang.editCriterias}
						<Elevio articleId={547} />
					</span>
					<div className="toggle-button-wrap" onClick={filterSelection.toggleExpand}>
						<button className="btn-round">
							<i className="fa fa-chevron-up" />
						</button>
						<button className="btn up-btn btn-link btn-grey">{this.lang.hideCriterias}</button>
					</div>
				</div>
				{includeCards}
				<Card space="mbxl">
					<CriteriaTable
						filters={excludeFilter}
						{...filterSelection}
						listStateError={error}
						selectData={selectData}
						criteriaSelectAnchor={document.getElementById('segment-filter-v2')}
					/>
				</Card>
				<div className="footer" onClick={filterSelection.toggleExpand}>
					<div className="collapse-segment-filter">
						<button className="btn-round">
							<i className="fa fa-chevron-up" />
						</button>
						<span>{this.lang.hideCriterias}</span>
					</div>
				</div>
			</div>
		);
	}

	collapsed(count) {
		const { filterSelection } = this.props;

		const translate = Tools.$translate;
		const numberCriteriasDescription = translate(this.lang.numberOfCriterias, {
			count: count,
			criterias: count === 1 ? this.lang.criteria : this.lang.criterias
		});

		return (
			<div key="collapsed" className="collapsed-wrapper" onClick={filterSelection.toggleExpand}>
				<div className="left-side">
					<div className="text">{numberCriteriasDescription}</div>
					<div className="expand-button-wrap">
						<button className="btn-round">
							<i className="fa fa-chevron-down" />
						</button>
						<span>{this.lang.clickToEdit}</span>
					</div>
				</div>
				<div className="right-side">
					<img src="img/contact-funnel.svg" />
				</div>
			</div>
		);
	}

	render() {
		const { segment, filterSelection, getExcludeFilter, getIncludeFilter } = this.props;
		const state = filterSelection.state;

		const excludeFilter = getExcludeFilter(segment);
		const includeConfigCount =
			Object.keys(getIncludeFilter(segment, false)?.config || {}).length +
			Object.keys(getIncludeFilter(segment, true)?.config || {}).length;
		const count = Object.keys(excludeFilter.config).length + includeConfigCount;

		const className = state.expanded ? 'expanded' : 'collapsed';

		return (
			<div id="segment-filter-v2" className={className}>
				{this.collapsed(count)}
				{this.expanded()}
			</div>
		);
	}
}

FilterContainer.propTypes = {
	filterSelection: PropTypes.object.isRequired,
	segment: PropTypes.object.isRequired,
	getExcludeFilter: PropTypes.func.isRequired,
	getIncludeFilter: PropTypes.func.isRequired,
	listState: PropTypes.object,
	selectData: PropTypes.object
};

export default FilterContainer;
